<template>
  <VCard flat>
    <VCardTitle><h2>{{ $nt('heading') }}</h2></VCardTitle>
    <VCardText>
      <p>{{ $nt('body') }}</p>
      <!-- Checkbox :loading prop not work (vuetify 1.3.0) but on elsazeit (vuetify 1.2.6) it works -->
      <VCheckbox
        v-model="acceptedGdpr"
        :loading="isLoading"
        :disabled="isLoading"
        :label="$nt('acceptGdpr')"
      />
      <VAlert
        :value="acceptedGdpr"
        type="success"
      >
        {{ $nt('validGdpr', accepted) }}
      </VAlert>
    </VCardText>
  </VCard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'GdprSettings',
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    accepted () {
      if (this.getUser.accepted_dpp) {
        const date = this.$moment(this.getUser.accepted_dpp, 'YYYY-MM-DD hh:mm:ss')
        return {
          date: date.format('DD.MM.YYYY'),
          time: date.format('hh:mm')
        }
      }
      return null
    },
    acceptedGdpr: {
      get () {
        return Boolean(this.getUser.accepted_dpp)
      },
      async set (value) {
        this.isLoading = true
        await this.updateGdpr(value)
        this.isLoading = false
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateGdpr'])
  }
}
</script>
